<template>
  <div>
    <label for="check">
      <i class="fas fa-bars" id="btn">
        <font-awesome-icon :icon="['fas', 'bars']"
      /></i>
      <i class="fas fa-times" id="cancel"
        ><font-awesome-icon :icon="['fas', 'times']"></font-awesome-icon
      ></i>
    </label>
    <div class="sidebar">
      <header>管理系統</header>
      <ul>
        <router-link :to="{ name: 'dashboard' }" class="adminGuide">
          控制臺
        </router-link>
        <router-link :to="{ name: 'backproduct' }" class="productGuide">
          產品列表
        </router-link>
        <router-link :to="{ name: 'backcoupon' }" class="couponGuide">
          優惠卷列表
        </router-link>
        <router-link :to="{ name: 'order' }" class="orderGuide">
          訂單列表
        </router-link>
        <router-link :to="{ name: 'storage' }" class="stoargeGuide">
          檔案列表
        </router-link>
        <router-link :to="{ name: 'backguide' }">
          功能導覽
        </router-link>
        <li @click="logoutHandler">
          <a href="#">登出</a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { mapMutations } from 'vuex';
export default {
  methods: {
    ...mapMutations(['SET_USER']),
    logoutHandler() {
      document.cookie = `token=;expires="";path=/`;
      this.SET_USER({
        token: '',
        uuid: '',
      });
      this.$router.push({ name: 'login' });
      alert('登出');
    },
  },
};
</script>
